import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postOrganizationResponse = async (message) => {
  const apiURL = API_HOST + '/organization_responses';
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.post(apiURL,{
      organization_response:{
        message: message
      }
    },{
      headers: {
      'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
    }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
